<template>
  <div class="form-field" :class="{ 'has-error': error }">
    <label v-if="label" :for="id" class="form-label">
      {{ label }}<span v-if="required" class="required" aria-hidden="true">*</span>
    </label>
    <slot :id="id" :invalid="Boolean(error)" />
    <p v-if="error" :id="`${id}-error`" class="form-field__error" role="alert">{{ error }}</p>
    <p v-else-if="hint" class="form-field__hint">{{ hint }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, default: "" },
  error: { type: String, default: "" },
  hint: { type: String, default: "" },
  required: { type: Boolean, default: false },
  id: { type: String, default: () => `field-${Math.random().toString(36).slice(2, 9)}` },
});
</script>

<style scoped>
.form-field {
  margin-bottom: 0.9rem;
  text-align: left;
}
.form-label {
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}
.required {
  color: hsl(var(--destructive));
  margin-left: 0.15rem;
}
.form-field__error {
  margin: 0.3rem 0 0;
  font-size: 0.78rem;
  color: hsl(var(--destructive));
}
.form-field__hint {
  margin: 0.3rem 0 0;
  font-size: 0.78rem;
  color: hsl(var(--muted-foreground));
}
.has-error :deep(.form-control),
.has-error :deep(.form-select) {
  border-color: hsl(var(--destructive));
}
</style>
